// export const users = [
//   {id: 1, first_name: "Sendi", last_name: "Dwi Putra", google_email: "sendi@gmail.com", mobile: "09999999999", social: {instagram: "sendi", youtube: "sendi"}, created_at: "2018-04-01T03:02:44.587Z" },
//   {id: 2, first_name: "Billy", last_name: "Ching", google_email: "billy@gmail.com", mobile: "09999999999", social: {instagram: "billy", youtube: "billy"}, created_at: "2018-04-01T03:02:44.587Z" },
//   {id: 3, first_name: "Wvgen", last_name: "Wong", google_email: "wvgen.wong@gmail.com", mobile: "09999999999", social: {instagram: "wvgen", youtube: "wvgen"}, created_at: "2018-04-01T03:02:44.587Z" },
//   {id: 4, first_name: "Ronadi", last_name: "", google_email: "ronadix@gmail.com", mobile: "09999999999", social: {instagram: "ronadi", youtube: "ronadi"}, created_at: "2018-04-01T03:02:44.587Z" }
// ];
export { agencyMarketerReceived } from './AgencyMarketerReceived';
export { default as agencymarketer} from './agencymarketerReducer';


// WEBPACK FOOTER //
// ./src/agency/redux/index.js